/**
 * Matches Contentful validation list (short strings / underscores). Extend when enums change.
 * Values map to legacy `page--*` suffixes (`homepage` → `home-page`) and blog article variants → `blog-page`.
 *
 * Unknown values fall through {@link pageTypeBodySlug}.
 *
 * @type {Record<string, string>}
 */
const CMS_PAGE_TYPE_TO_BODY_SUFFIX = {
  homepage: 'home-page',
  landing: 'landing',
  blog: 'blog-page',
  product: 'product-page',
  category: 'category-listing-page',
  store: 'store-detail-page',
  generic: 'generic-page',
  blog_article_img: 'blog-article-img',
  blog_article_content: 'blog-article-content',
  content: 'content',
};

const normalizeCmsPageTypeKey = (raw) =>
  String(raw)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');

/**
 * Resolved suffix for {@link useBodyPageType}: CMS `pageType` → `page--<suffix>`.
 *
 * @param {unknown} raw
 * @returns {string|undefined}
 */
export const contentfulPageTypeBodySuffix = (raw) => {
  if (raw == null || raw === '') return undefined;

  const key = normalizeCmsPageTypeKey(raw);
  const mapped = CMS_PAGE_TYPE_TO_BODY_SUFFIX[key];

  return mapped ?? pageTypeBodySlug(raw);
};

/**
 * Normalize Contentful `Page.pageType` (short text) for a `body.page--*` class suffix.
 * Hyphenated to match existing body classes (e.g. `page--blog-page`).
 *
 * @param {unknown} raw
 * @returns {string|undefined}
 */
export const pageTypeBodySlug = (raw) => {
  if (raw == null || raw === '') return undefined;

  const slug = String(raw)
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug === '' ? undefined : slug;
};
